import { useMutation } from "react-query";
import { storeOnboarding, sendOnboarding } from "../../../../../services/vmApi";

export function useSaveOnboarding(options) {
  return useMutation(data => storeOnboarding(data), options);
}

export function useSendOnboarding(options) {
  return useMutation(data => sendOnboarding(data), options);
}
